import config from "config/config";
import getTokens from "api/getTokens";

const  { baseUrl, clientUrl } = config;
/* *********************

********************** */

export default function mfaQrCode(user) {
  // const { refresh } = getTokens();
  const endpoint = `${baseUrl}/v1/auth/mfa-qr-code`;
  let access = "";
  const tokens = getTokens();
  if (tokens && tokens.access && tokens.access.token) {
    access = tokens.access.token;
  } else {
    window.location.href = "/login";
  }
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
      Authorization: `bearer ${access}`,
    },
    body: JSON.stringify({ user }),
  };
  // console.log("DATI PER QR CHIAMATA", endpoint, options);
  return fetch(endpoint, options)
    .then((response) => {
      // console.log("RESPONSE QR CHIAMATA", response);
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        throw new Error();
      }
      return response.blob();
    })
    .catch((e) => {
      // eslint-disable-next-line
      console.log("error", e);
    });
}
